// extracted by mini-css-extract-plugin
export default {"whatsappBtn":"WhatsAppButton_whatsappBtn__VojEf","icon":"WhatsAppButton_icon__8RMOn","label":"WhatsAppButton_label__eA1Oz"};